import { defaultEnvironment, Environment } from './environments.default';

export const environment: Environment = {
  ...defaultEnvironment,
  env: 'development',
  baseUrl: 'https://selfserve.apis.dev.rogersbank.com',
  icBaseUrl: 'https://ic.dev.rogersbank.com',
  icCardViewerBaseUrl: 'https://cardviewer.dev.rogersbank.com',
  icViewCardDetailsBaseUrl:
    'https://ic.dev.rogersbank.com/viewcardtermsvalidation',
  registerUrl: 'https://uat.tsysweb.com/?product=ROGERSBRAND',
  webregisterUrl: 'https://uat.tsysweb.com/app/forgotusername',
  coorpUserLoginUrl: 'https://uat.tsysweb.com/?product=ROGERSCORP',
  REACT_APP_ADOBE_DTM_URL:
    'https://assets.adobedtm.com/8cf1b6f99d16/ce7953ba12d7/launch-939ed555bd43-staging.min.js',
  adobeUrl:
    'https://assets.adobedtm.com/8cf1b6f99d16/ce7953ba12d7/launch-939ed555bd43-staging.min.js',
  contentful: {
    ...defaultEnvironment.contentful,
    cdk: 'crPP1qad3L1Q4RzHXtjLGCOII3_UtgCqMyguTaMJ-0U',
    environment: 'dev',
  },
  loyaltyHubLogoutUrl: 'https://selfserve.dev.rogersbank.com',
  loyaltyHubDashboardUrl: 'https://staging.offers.rogersbank.com',
  dynaBeaconUrl:
    'https://js-cdn.dynatrace.com/jstag/17a2d2e42ea/bf97268ops/e5181422d25721b1_complete.js',
  dynaAppId: '9675eefe-0d14-46e1-a766-934e0d05b23a',
  linkAccUrl:
    'https://qa5.rogers.com/consumer/profile/signin?lang=en&platform=iOS&&redirectAppUrl=http://localhost:4200/link-account&source=RogersBankXPlatform&relogin=true',
  recaptchaSiteKey: '6LeqXH8rAAAAACgorCIXmOrTNZ1masljGxcGi2hZ',
  brazeWeb: {
    apiKey: 'bc949fc7-9b36-4819-bda8-e42a4010b789',
    endpoint: 'sdk.iad-07.braze.com',
    enableLogging: true,
    manageServiceWorkerExternally: false,
    serviceWorkerLocation: '/service-worker.js',
    enableSdkAuthentication: true,
    safariWebsitePushId: 'web.com.rogersbank.selfserve.dev',
  },
  //recaptchaSiteKey: '6LctgHorAAAAAJ9b6XOBCxSXG_80Xhl1cGTf7JUi',
};
